import { ContactPhone, Phone, Email } from '@mui/icons-material';
import { Box } from '@mui/material';
import React from 'react';

import {
  AddressLabel,
  CallButton,
  ContactCard,
  ContactCardContent,
  ContactName,
  ContactType,
  ContactDetail,
} from './MobileLocationSection.styles';
import { StructureAttribute } from '../../../../../@types';
import { COLORS } from '../../../../../configs/colors';

const iconSx = { fontSize: 13, color: COLORS.Gray } as const;

export const LocationContactsList: React.FC<{ contacts: StructureAttribute[] }> = ({
  contacts,
}) => (
  <Box>
    <AddressLabel>
      <ContactPhone sx={{ fontSize: 14, verticalAlign: 'middle', mr: 0.5 }} />
      Contacts
    </AddressLabel>
    {contacts.map((contact) => {
      const v = contact.value;
      const primaryPhone = v?.phone1 || v?.phone2;
      return (
        <ContactCard key={contact.id}>
          <ContactCardContent>
            {v?.contactType && <ContactType>{v.contactType}</ContactType>}
            {v?.contactName && <ContactName>{v.contactName}</ContactName>}
            {v?.phone1 && (
              <ContactDetail>
                <Phone sx={iconSx} />
                {v.phone1}
              </ContactDetail>
            )}
            {v?.phone2 && (
              <ContactDetail>
                <Phone sx={iconSx} />
                {v.phone2}
              </ContactDetail>
            )}
            {v?.email && (
              <ContactDetail>
                <Email sx={iconSx} />
                {v.email}
              </ContactDetail>
            )}
          </ContactCardContent>
          {primaryPhone && (
            <a href={`tel:${primaryPhone}`} aria-label={`Call ${v?.contactName || primaryPhone}`}>
              <CallButton>
                <Phone sx={{ fontSize: 20 }} />
              </CallButton>
            </a>
          )}
        </ContactCard>
      );
    })}
  </Box>
);
